var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.288 25.76C16.1417 27.7066 16.5685 29.7867 16.5685 32C16.5685 29.7867 16.9816 27.7066 17.8084 25.76C18.6614 23.8133 19.8082 22.12 21.248 20.68C22.6885 19.24 24.3814 18.1067 26.3281 17.28C28.2748 16.4267 30.3551 16 32.568 16C30.3551 16 28.2748 15.5867 26.3281 14.76C24.3814 13.9067 22.6885 12.76 21.248 11.32C19.8082 9.88 18.6614 8.18668 17.8084 6.24C16.9816 4.29333 16.5685 2.21333 16.5685 0C16.5685 2.21333 16.1417 4.29333 15.288 6.24C14.4619 8.18668 13.3282 9.88 11.8884 11.32C10.4485 12.76 8.75498 13.9067 6.80831 14.76C4.86165 15.5867 2.78187 16 0.568359 16C2.78187 16 4.86165 16.4267 6.80831 17.28C8.75498 18.1067 10.4485 19.24 11.8884 20.68C13.3282 22.12 14.4619 23.8133 15.288 25.76Z",
    fill: "url(#paint0_linear_9478_26387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9478_26387",
    x1: 10.2121,
    y1: 7.18673,
    x2: 15.8365,
    y2: 15.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo5.54429f73c23b5ba1f6f42616d1dd2d90.svg";
export { ForwardRef as ReactComponent };